import { initializeApp, type FirebaseApp } from 'firebase/app'
import { getFirestore, type Firestore } from 'firebase/firestore'
import { getStorage, type FirebaseStorage } from 'firebase/storage'
import { env } from '@/config/env'

export const firebaseConfig = {
  apiKey: env.firebase.apiKey,
  authDomain: env.firebase.authDomain,
  projectId: env.firebase.projectId,
  storageBucket: env.firebase.storageBucket,
  messagingSenderId: env.firebase.messagingSenderId,
  appId: env.firebase.appId,
  measurementId: env.firebase.measurementId,
}

export const firebaseApp: FirebaseApp = initializeApp(firebaseConfig)
export const firestoreDb: Firestore = getFirestore(firebaseApp)
export const firebaseStorage: FirebaseStorage = getStorage(firebaseApp)
